<script>
import HorizontalScroll from "../../../components/core/horizontal-scroll.vue";
import {urlEncoder} from "../../../core/utils/url";
import {money} from "../../../core/forms/money";
import Data from "../../../core/data/Data";

export default {
    name: 'Billers',
    components: {HorizontalScroll},
    metaInfo: {
        title: 'Billers'
    },
    mixins: [urlEncoder, money],
    data: () => ({
        bills: new Data({
            url: '/billers/list',
            prefix: 'list'
        }),
    }),
    computed: {
        billers() {
            return this.bills.content.data.map(bill => ({...bill, biller_id: this.encode(bill.id)}));
        },
    },
    methods: {
        async getBillers() {
            await this.bills.fetch();
        },
        truncateText(text, length){
            return text.length > length ? text.substring(0, length) + '...' : text;
        }
    },
    async mounted() {
        await this.getBillers();
    }
}
</script>

<template>
    <section class="bg-light-1 py-4">
        <div class="container">
            <div class="d-flex align-items-center justify-content-between">
                <h2 class="title-blog text-7">Billers</h2>

                <router-link
                    to="/billers/landing"
                    class="btn btn-primary btn-sm">
                    Become a Biller
                </router-link>
            </div>
            <hr class="my-4">
            <div v-if="bills.loading"
                 class="text-center text-primary text-20 line-height-07 mb-5 mt-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>

            <div class="row">
                <template v-for="(biller, index) in billers">
                    <router-link
                        :to="`/billers/pay/${biller.biller_id}/${biller.name.toLowerCase().replace(/ /g, '-').replace(/\//g, '')}`"
                        class="col-xl-4 col-lg-6 col-md-6 col-12 px-3 mb-4"
                    >
                        <div :key="'event' + index" class="biller-card p-3 shadow-sm rounded-lg">
                            <div class="row">
                                <div class="col-4 border-right">
                                    <img class="card-img-top" :src="biller.image" :alt="biller.name">
                                </div>
                                <div class="col-8 d-flex align-items-center">
                                    <strong class="title-blog text-left text-wrap">
                                        {{ truncateText(biller.name, 57) }}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </template>
            </div>


            <!-- Pagination ============================================= -->
            <ul v-if="bills.content.last_page > 1" class="pagination justify-content-center my-5">
                <li class="page-item disabled" v-if="bills.content.current_page > 1">
                    <a class="page-link" href="#" @click="bills.fetchPrevious()" tabindex="-1">
                        <i class="fas fa-angle-left"></i>
                    </a>
                </li>
                <template v-for="page in bills.content.last_page">
                    <li class="page-item"
                        v-if="page > bills.content.current_page - 3 && page < bills.content.current_page + 3"
                        :key="'page' + page"
                        :class="[page === bills.content.current_page ? 'active' : '']">
                        <a class="page-link" href="#" @click="bills.fetchPage(page)">{{ page }}</a>
                    </li>
                </template>
                <li v-if="bills.content.last_page > 6"
                    class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">...
                </li>
                <li class="page-item" v-if="bills.content.current_page < bills.content.last_page">
                    <a class="page-link" href="#" @click="bills.fetchNext()">
                        <i class="fas fa-angle-right"></i>
                    </a>
                </li>
            </ul>
            <!-- Pagination end -->
        </div>
    </section>
</template>

<style scoped>

.title-blog {
    word-wrap: break-word;
    text-align: center;
    white-space: normal;
}

.card-img-top {
    object-fit: cover;
    width: 100%;
    height: auto;
}

.biller-card{
    background-color: #fff;
}

.row > .col-lg-4,
.row > .col-md-4,
.row > .col-6 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

</style>
